//Add strings
gdprCookieNoticeLocales.de = {
  bar_title: "Diese Webseite verwendet Cookies",
  description:
    "Wir verwenden Cookies, um Ihnen ein besseres Browser Erlebnis bieten zu können, Inhalte und Anzeigen zu personalisieren, Ihnen Zugang zu sozialen Medien zu ermöglichen und den Website-Traffic zu analysieren. Für weitere Informationen darüber, wie wir Cookies verwenden und wie Sie diese selbst verwalten können, klicken Sie auf Cookie-Einstellungen. Sie stimmen der Verwendung von Cookies zu, wenn Sie diese Webseite und deren Angebote weiter nutzen.",
  settings: "Cookie Einstellungen",
  accept: "Akzeptieren und Fortfahren",
  save: "Änderungen Speichern",
  policy: "Weitere Infomationen",
  manage: "Cookies Verwalten",
  toggle_button_first: "Cookie",
  toggle_button_second: "Einstellungen",
  always_on: "Immer eingeschaltet",
  cookie_essential_title: "Notwendige Cookies für die Webseite",
  cookie_essential_desc:
    "Notwendige Cookies helfen dabei, eine Webseite nutzbar zu machen, indem sie Grundfunktionen wie Seitennavigation und Zugriff auf sichere Bereiche der Webseite ermöglichen. Diese Webseite kann ohne diese Cookies nicht richtig funktionieren.",
  cookie_performance_title: "Performance Cookies",
  cookie_performance_desc:
    "Diese Cookies werden verwendet, um die Leistung und Funktionalitäten unserer Website zu verbessern, sind aber für deren Verwendung nicht erforderlich. Diese speichern zum Beispiel Ihre bevorzugte Sprache oder die Region, in der Sie sich befinden.",
  cookie_analytics_title: "Analytics Cookies",
  cookie_analytics_desc:
    "Wir verwenden Analytik-Cookies, um zu verstehen, wie Nutzer mit Webseite-Inhalten interagieren. Mit diesen Cookies können wir unsere Webseiten und Apps für Sie anpassen, um die Nutzerfreundlichkeit zu verbessern.",
  cookie_marketing_title: "Marketing Cookies",
  cookie_marketing_desc:
    "Diese Cookies werden verwendet, um Anzeigen zu personalisieren. Ziel ist es, Anzeigen zu zeigen, die für den einzelnen Nutzer relevant und ansprechend sind und damit für Publisher und Dritte wertvoller sind."
};
